Shopware.Component.override('sw-dashboard-index', () => import('./page/sw-dashboard-index'));
Shopware.Component.register('sw-dashboard-statistics-promotion-card', () => import('./component/sw-dashboard-statistics-promotion-card'));
